module.exports = __webpack_public_path__ + "img/duck-blue.4aad343a.svg";